import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { useCallback } from "react";

export function useErrorTracker(): (
  error: Error,
  properties?: Record<string, unknown>,
) => void {
  const appInsights = useAppInsightsContext();

  return useCallback(
    (error: Error, properties?: Record<string, unknown>) => {
      appInsights.trackException({
        exception: error,
        severityLevel: SeverityLevel.Error,
        properties,
      });
    },
    [appInsights],
  );
}
